import React from "react";

const menuItemStyleBlue = {
  padding: "14px 10px 14px 20px",
  color: "#0071BB",
  cursor: "pointer",
};

const RemoveLinkedProfile = ({
  id,
  formApi,
  machineName,
  removedProfilesMachineName,
  setLinkedProfiles,
  linkedProfiles,
}) => {
  const removeLinkedProfile = () => {
    const profiles = formApi.getState().values[machineName];
    const newProfiles = profiles.filter((linkedId) => linkedId !== id);
    formApi.change(machineName, newProfiles);
    setLinkedProfiles(linkedProfiles.filter((ids) => id !== ids));

    if (!!removedProfilesMachineName) {
      const removedProfiles =
        formApi.getState().values?.[removedProfilesMachineName] ?? [];
      console.log([...removedProfiles, id]);
      formApi.change(removedProfilesMachineName, [...removedProfiles, id]);
    }
  };

  return (
    <div style={menuItemStyleBlue} className="menu-item dropdown-label-View">
      <a onClick={removeLinkedProfile}>Remove</a>
    </div>
  );
};

export default RemoveLinkedProfile;
